import {
  useScanDataSubmissionHealthMetricsQuery,
  ScanDataSubmissionHealthMetricsQueryVariables,
} from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';

export const useScanDataSubmissionHealthMetrics = (
  variables: ScanDataSubmissionHealthMetricsQueryVariables,
) => {
  return useScanDataSubmissionHealthMetricsQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables,
  });
};
